/**
 * Shared admin auth helpers for AdminDashboard child components.
 * Centralised so the same token/origin logic isn't duplicated across modals.
 */
export const API = `${window.location.origin}/api`;

export function getAuthHeaders() {
  const token = localStorage.getItem('admin_token');
  return { Authorization: `Bearer ${token}` };
}
